import React from 'react';
import {useParams} from "react-router-dom";
import UserData from "../components/Users/UserData";
import UserInfo from "../components/Users/UserInfo";

const User = () => {

    const params = useParams();
    const id = params.id


    return (<div>

            <div className="md-dashboard-container p-0">

                <div className={"display-flex flex-direction-column w-100 gap-20"}>
                    {/* Fiche bandeau de l'utilisateur */}
                    <UserData id={id}/>

                    {/* Partie avec les infos modifiables de l'utilisateur */}
                    <UserInfo user={id}/>

                </div>
            </div>
        </div>


    );
};

export default User;